<div class="modal-header">
  <h4 class="modal-title">{{ 'job-description.modal-title' | translate }}</h4>
  <button type="button" class="btn-close" aria-label="close" (click)="cancel()"></button>
</div>
<div class="modal-body">
  <div class="description">{{ 'job-description.modal-description' | translate }}</div>
  <div class="input-container">
    <label for="job-input">{{ 'job-description.modal-input-label' | translate }}</label>
    <input
      id="job-input"
      type="text"
      placeholder="{{ 'job-description.modal-input-placeholder' | translate }}"
      [(ngModel)]="role"
      [maxlength]="ROLE_CHAR_LIMIT"
    />
  </div>
  <div class="tip">{{ 'job-description.modal-tip' | translate }}</div>
</div>
<div class="modal-footer">
  <button type="button" class="cancel fw-bold" (click)="cancel()">{{ 'common.cancel' | translate }}</button>
  <ex-button type="primary" variant="raised" [disabled]="role.trim().length === 0" (click)="confirm()">
    {{ 'common.save' | translate }}
  </ex-button>
</div>
